module.exports = __webpack_public_path__ + "img/ECO-EE.d02928f9.svg";